const f = {
  color: {
    green: {
      main: "#e0fcdeff",
      hover: "#b9edbdff",
      text: "#314351ff",
      textHover: "#253642ff"
    },
    grey: {
      main: "#f1f3f5ff",
      hover: "#dfe6ebff",
      text: "#314351ff",
      textHover: "#253642ff"
    },
    purple: {
      main: "#f2e5ffff",
      hover: "#d7baf5ff",
      text: "#774ba3ff",
      textHover: "#5d407aff"
    },
    white: {
      main: "#ffffffff",
      hover: "#f1f3f5ff",
      text: "#314351ff",
      textHover: "#253642ff"
    },
    blue: {
      main: "#304ddbff",
      hover: "#263aadff",
      text: "#ffffffff",
      textHover: "#ffffffff"
    },
    charcoal: {
      main: "#131b24ff",
      hover: "#314351ff",
      text: "#c8d3deff",
      textHover: "white"
    },
    clay: {
      main: "#f5f2f0ff",
      hover: "white",
      text: "#4a4441ff",
      textHover: "#33302eff"
    },
    disabled: {
      border: "#c8d3deff",
      main: "#ffffffff",
      text: "#c8d3deff"
    }
  }
};
export {
  f as buttonIcon
};
